const bankInfo = {
  35: {
    bankId: '35',
    bankName: '中国建设银行',
    bankIcon: 'https://p1.meituan.net/wxapp/a449d142381490dca047e3dac5319a20756.png',
    bankIconByColor: 'https://p1.meituan.net/wxapp/e140ef630fbf3c6286db946fe9c808d4568.png',
    guideLink: 'https://cube.meituan.com/cube/block/9d9f6352c42ddab72293/211539/index.html',
    couponGuide: 'https://cube.meituan.com/cube/block/cc6b013726178b608b43/217909/index.html',
    redpctGuide: 'https://cube.meituan.com/cube/block/214b855f1ae805cabf59/217913/index.html'
  },
  36: {
    bankId: '36',
    bankName: '中国工商银行',
    bankIcon: '',
    guideLink: ''
  },
  37: {
    bankId: '37',
    bankName: '中国农业银行',
    bankIcon: '',
    guideLink: ''
  },
  38: {
    bankId: '38',
    bankName: '中国招商银行',
  },
  39: {
    bankId: '39',
    bankName: '中国银行',
    bankIcon: 'https://p0.meituan.net/wxapp/fed4af485d632993e9ae9b94a078d095868.png',
    bankIconByColor: 'https://p0.meituan.net/wxapp/5e33ef600c0106f144616406550664ed724.png',
    guideLink: 'https://cube.meituan.com/cube/block/8df931bf5c5fcb1fbe72/211534/index.html',
    couponGuide: 'https://cube.meituan.com/cube/block/0e5acfe7813632599751/217906/index.html',
    redpctGuide: 'https://cube.meituan.com/cube/block/1e6c0400833a3fa6e53d/217911/index.html'
  },
  40: {
    bankId: '40',
    bankName: '交通银行',
    bankIcon: 'https://p1.meituan.net/wxapp/374a40717425a28b2da233d2bcb55b3d717.png',
    bankIconByColor: 'https://p0.meituan.net/wxapp/60834456d2baf7b4b553106461d5d5a0765.png',
    guideLink: 'https://cube.meituan.com/cube/block/2cf7fe8830e011aaa280/211538/index.html',
    couponGuide: 'https://cube.meituan.com/cube/block/166b96d94baa49aa8916/217910/index.html',
    redpctGuide: 'https://cube.meituan.com/cube/block/80100a7306d40c6476a7/217914/index.html'
  },
  41: {
    bankId: '41',
    bankName: '中国邮政储蓄银行',
    bankIcon: 'https://p0.meituan.net/wxapp/2ff6b0d25800d3ff4070ea3c66b7c468727.png',
    bankIconByColor: 'https://p1.meituan.net/wxapp/a191a26a916053cf71ff44343a77964a546.png',
    guideLink: 'https://cube.meituan.com/cube/block/29d680d8f97a33880776/211535/index.html',
    couponGuide: 'https://cube.meituan.com/cube/block/1ec0fae527ea29714325/217908/index.html',
    redpctGuide: 'https://cube.meituan.com/cube/block/d0f82c2b60077e6a365a/217912/index.html'
  }
};

export {
  bankInfo
};
